import React, { useState } from "react";
import { stratificationService } from "../../services/stratification.services";
import { SearchSelect } from "./SearchSelect";
import { TrashCan } from "../Icons/TrashCan";

export const RiskAtcGroupsSection = ({ items, onRefresh }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [showAddForm, setShowAddForm] = useState(false);
  const [selectedAtc, setSelectedAtc] = useState(null);
  const [selectedArea, setSelectedArea] = useState(null);
  const [saving, setSaving] = useState(false);

  const handleSearchAtc = async (query) => {
    const data = await stratificationService.searchAtcGroups(query);
    return data.results || [];
  };

  const handleSearchArea = async (query) => {
    const data = await stratificationService.searchCheckinAreas(query);
    return data.results || [];
  };

  const handleAdd = async () => {
    if (!selectedAtc) return;
    setSaving(true);
    try {
      await stratificationService.createRiskAtcGroup({
        atc_group_id: selectedAtc.id,
        checkin_area_id: selectedArea?.id || null,
      });
      setSelectedAtc(null);
      setSelectedArea(null);
      setShowAddForm(false);
      setIsExpanded(true);
      onRefresh();
    } catch (err) {
      console.error("Error creating risk ATC group:", err);
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Opravdu chcete odstranit tuto ATC skupinu?")) return;
    try {
      await stratificationService.deleteRiskAtcGroup(id);
      setIsExpanded(true);
      onRefresh();
    } catch (err) {
      console.error("Error deleting risk ATC group:", err);
    }
  };

  return (
    <div className="strat-section">
      <div
        className="strat-section-header"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <h3 className="strat-section-title">Rizikové ATC skupiny</h3>
        <span className="strat-section-toggle">{isExpanded ? "−" : "+"}</span>
      </div>

      {isExpanded && (
        <div className="strat-section-content">
          {/* Table header */}
          <div className="strat-table-header">
            <div className="strat-header-cell strat-cell--code">Kód</div>
            <div className="strat-header-cell strat-cell--name">
              Název ATC skupiny
            </div>
            <div className="strat-header-cell strat-cell--area">
              Oblast vstupní kontroly
            </div>
            <div className="strat-header-cell strat-cell--actions" />
          </div>

          {/* Rows */}
          {items.length === 0 && !showAddForm && (
            <div className="strat-empty">
              Žádné rizikové ATC skupiny nebyly přidány.
            </div>
          )}

          {items.map((item, idx) => (
            <div
              key={item.id}
              className={`strat-row ${idx % 2 === 1 ? "strat-row--odd" : ""}`}
            >
              <div className="strat-cell strat-cell--code">
                {item.atc_group?.code || ""}
              </div>
              <div className="strat-cell strat-cell--name">
                {item.atc_group?.name || ""}
              </div>
              <div className="strat-cell strat-cell--area">
                {item.checkin_area?.name || "Polypragmázie"}
              </div>
              <div className="strat-cell strat-cell--actions">
                <button
                  className="strat-action-btn strat-action-btn--delete"
                  onClick={() => handleDelete(item.id)}
                  title="Odstranit"
                >
                  <TrashCan className="strat-action-icon" />
                </button>
              </div>
            </div>
          ))}

          {/* Add form */}
          {showAddForm && (
            <div className="strat-inline-form">
              <div className="strat-inline-field strat-inline-field--grow">
                <span className="strat-inline-label">ATC skupina</span>
                <SearchSelect
                  placeholder="Vyhledat ATC skupinu (kód / název)..."
                  onSearch={handleSearchAtc}
                  onSelect={setSelectedAtc}
                  renderOption={(item) => (
                    <>
                      <span className="strat-search-option--code">
                        {item.code}
                      </span>
                      {item.name}
                    </>
                  )}
                />
                {selectedAtc && (
                  <small>
                    Vybráno: {selectedAtc.code} – {selectedAtc.name}
                  </small>
                )}
              </div>
              <div className="strat-inline-field strat-inline-field--grow">
                <span className="strat-inline-label">
                  Oblast vstupní kontroly (nepovinné)
                </span>
                <SearchSelect
                  placeholder="Vyhledat oblast..."
                  onSearch={handleSearchArea}
                  onSelect={setSelectedArea}
                  renderOption={(item) => item.name}
                />
                {selectedArea && <small>Vybráno: {selectedArea.name}</small>}
              </div>
              <div style={{ display: "flex", gap: 8, alignSelf: "flex-end" }}>
                <button
                  className="strat-add-btn"
                  onClick={handleAdd}
                  disabled={!selectedAtc || saving}
                >
                  {saving ? "Ukládání..." : "Uložit"}
                </button>
                <button
                  className="strat-add-btn strat-add-btn--secondary"
                  onClick={() => {
                    setShowAddForm(false);
                    setSelectedAtc(null);
                    setSelectedArea(null);
                  }}
                >
                  Zrušit
                </button>
              </div>
            </div>
          )}

          {/* Add button */}
          <div className="strat-add-row">
            <button
              className="strat-add-btn"
              onClick={() => setShowAddForm(true)}
              disabled={showAddForm}
            >
              + Přidat ATC skupinu
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
